import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {FromShipping} from '../models/shipping';

export const shippingAddActionTypes = {
  ADD: type('[shipping] Add'),
  ADD_SUCCESS: type('[shipping] Add Success'),
  ADD_FAIL: type('[shipping] Add Fail'),
};

export class AddShippingAction implements Action {
  readonly type = shippingAddActionTypes.ADD;
  constructor(public payload?:  {data: FromShipping}) {}
}

export class AddShippingSuccessAction implements Action {
  readonly type = shippingAddActionTypes.ADD_SUCCESS;
  constructor() {}
}

export class AddShippingFailAction implements Action {
  readonly type = shippingAddActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}
